<template>
     <div>
      <h1>{{ $t('help.ISAMonthlyReportHelp_title') }}</h1>
      <p class="text-justify">
          {{ $('When this feature is enabled, the users in this care unit will receive a monthly report of ISA detection.') }}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
